import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const ArrowLeftIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        width="24"
        height="22"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
        fill={theme.colors.primary.variant1}
      >
        <path d="M426.666667 170.666667q17.664 0 30.165333 12.501333t12.501333 30.165333q0 18.005333-12.672 30.336l-225.664 225.664 665.002667 0q17.664 0 30.165333 12.501333t12.501333 30.165333-12.501333 30.165333-30.165333 12.501333l-665.002667 0 225.664 225.664q12.672 12.330667 12.672 30.336 0 17.664-12.501333 30.165333t-30.165333 12.501333q-18.005333 0-30.336-12.330667l-298.666667-298.666667q-12.330667-13.013333-12.330667-30.336t12.330667-30.336l298.666667-298.666667q12.672-12.330667 30.336-12.330667z" />
      </svg>
    </Icon>
  );
};

export default ArrowLeftIcon;
